// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3h6EC","modalFooterButton":"ModalNotes_modalFooterButton__t0k8f"};